import React from 'react';
import { Box, Divider, ListItem, ListItemText } from '@mui/material';
import _ from 'lodash';

export interface SectionContainerProps {
  text: string;
  children: React.ReactNode;
}

const SectionContainer: React.FC<SectionContainerProps> = ({ text, children }) => (
  <Box sx={{ bgcolor: '#101F33' }}>
    <ListItem sx={{ py: _.isEmpty(text) ? 0 : 2, px: 3 }}>
      <ListItemText sx={{ color: '#fff' }}>{text}</ListItemText>
    </ListItem>
    {children}
    <Divider sx={{ mt: 2 }} />
  </Box>
);

export default SectionContainer;
